/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ goal: NonNullable<unknown> }} Platform_View_Diet_OfInputs */

const en_platform_view_diet_of = /** @type {(inputs: Platform_View_Diet_OfInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`of ${i?.goal} kcal`)
};

const pl_platform_view_diet_of = /** @type {(inputs: Platform_View_Diet_OfInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`z ${i?.goal} kcal`)
};

/**
* | output |
* | --- |
* | "of {goal} kcal" |
*
* @param {Platform_View_Diet_OfInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const platform_view_diet_of = /** @type {((inputs: Platform_View_Diet_OfInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Platform_View_Diet_OfInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_platform_view_diet_of(inputs)
	return en_platform_view_diet_of(inputs)
});